import { css, html, LitElement } from 'lit-element';
import {render} from 'lit-html';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import nls from '../../locales/index.nls';
import './ki-station-list-item';

export default
@i18n(nls)
class KiStationList extends LitElement {
  static styles = css`
    :host {
      display: block;
      width: 100%;
      height: 100%;
      color: grey;
      overflow: auto;
    }
    .parameter-list.hidden {
      height: 0;
      transition: height 0.4s ease-in-out 0s;
    }
    .station-list {
      margin-top:0;
    }
    .station-item {
      background: white;
      overflow: hidden;
      padding: 5px 0;
    }
    .parameter-list {
      height: 36px;
      padding-left: 0px;
      transition: height 0.4s ease-in-out 0s;
      margin-left: 20px;
      margin-right: 40px;
    }
    .parameter-item, .station-item .label {
      cursor: pointer;
    }

    .parameter-item.selected {
      background: var(--theme-color, #0056a0);
      color: white;
    }

    .parameter-list:hover, .parameter-list:focus{
      background-color: #eeeeee;
      color: var(--theme-color, #0056a0);
    }
    .label{
      white-space: nowrap;
      overflow: hidden;
      padding-right: 10px;
      text-overflow: ellipsis;
      width: 100%;
    }

    .label:hover, .label:focus{
      color: var(--theme-color, #0056a0);
    }

    .station-item div {
      display: flex;
      justify-content: space-between;
      margin-right: 15px;
    }

    .parameter-item{
      padding: 5px 0;
    }
    .parameter-item .icon {
      margin-right: 5px;
      vertical-align: text-top;
    }

    ul{
      list-style-type: none;
    }

    .selected svg.icon {
      fill: white;
    }

    svg.icon {
      width: 18px;
      fill: gray;
      cursor: pointer;
    }
    svg.icon:hover {
      fill: rgb(74, 74, 73);
    }
  `;

  static get properties() {
    return {
      data: { type: Array },
      stationLabelTemplate: { type: String },
      selectedTs: { type: Array }, // ts path eg: ["DCENN/L5021/H/Cmd.Rel.Abs-Alarmes"]
      multiple: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.data = [];
    this.value = [];
    this.multiple = true;
    this.chevronup = html`<svg class="icon" xmlns="http://www.w3.org/2000/svg" baseProfile="tiny" viewBox="0 0 18 18"><path d="M8.98 4.99L2 11.63l1.46 1.38 5.53-5.26 5.55 5.23L16 11.59z"/></svg>`;
    this.chevrondown = html`<svg  class="icon"  xmlns="http://www.w3.org/2000/svg" baseProfile="tiny" viewBox="0 0 18 18"><path d="M9.02 13.01L16 6.37l-1.46-1.38-5.53 5.26-5.55-5.23L2 6.41z"/></svg>`;
    this.tsicon = html`<svg  class="icon"  xmlns="http://www.w3.org/2000/svg" baseProfile="tiny" viewBox="0 0 18 18"><path d="M2 15V1H0v16h18v-2z"/><path d="M4.35 13.25L9.3 8.3l2.11 2.11L12.83 9l-.01-.01 1.41-1.4L15.65 9l1.42-1.41-1.42-1.42-1.41-1.42-2.83 2.83-2.12-2.12-1.41 1.41v.01l-4.95 4.95z"/></svg>
    `;

  }

  _createLabel(data) {
    return this.i18n.exists(data.ts_shortname.replace(/\./g, '_')) ? this.i18n.t(data.ts_shortname.replace(/\./g, '_')) : data.stationparameter_name;
  }

  _toggleChevron(node){
    const closed = node.getAttribute("closed")===null;
    const icon = closed ? this.chevrondown : this.chevronup;
    node.parentElement.parentElement.querySelector(".parameter-list").classList.toggle("hidden")
    render(icon, node);
    node.toggleAttribute("closed")
  }

  _getItem(data){
    return html`
      <div title="${data.label}"><span class="label" stpath="${data.value}" @click="${this._handleLabelClick}">${data.label}</span> <span closed @click="${(e) => {
        this._toggleChevron(e.currentTarget)
      }}">${this.chevrondown}</span></div>
    <ul class="parameter-list hidden">
      <li class="parameter-item ${this.selectedTs.includes(data.ts_path) ? "selected" : ""}" tspath="${data.ts_path}" @click="${this._handleClick}">${this.tsicon}  ${this._createLabel(data)}</li>
    </ul>`
  }

  render() {
    return html`
      <ul class="station-list">
        ${this.data.map(station => {
          return html`<li class="station-item">${this._getItem(station)}</li>`;
        })}
      </ul>
    `;
  }

  _handleLabelClick(e) {
    this.dispatchEvent(
      new CustomEvent('labelClicked', {
        detail: { value: e.currentTarget.getAttribute("stpath") },
        bubbles: true,
        composed: true,
      }),
    );
  }

  _handleClick(event) {
    const currentValue =event.currentTarget.getAttribute("tspath");
    event.stopPropagation();
  //  event.currentTarget.classList.toggle("selected")
    if (this.selectedTs) {
      this.value = [...this.selectedTs];
    }else{
      this.value = [];
    }
    const index = this.value?.indexOf(currentValue);
    if (this.multiple) {
      if (index !== -1) {
        this.value = [...this.value.slice(0, index), ...this.value.slice(index + 1)];
      } else {
        this.value = [...this.value, currentValue];
      }
    } else {
      const { length } = this.value;
      if (length === 0 || index === -1) {
        this.value = [currentValue];
      } else {
        this.value = [];
      }
    }

    this.dispatchEvent(
      new CustomEvent('itemSelected', {
        detail: { value: this.value },
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define('ki-station-list', KiStationList);
